// Reads the per-vehicle URL override saved by /content-admin (localStorage
// key "motorpro_content_admin_v1", written by pages/content-admin/adminStore.ts)
// so the public carousel's "Ver anuncio" link reflects local admin edits too.
// Read-only here — writing is only ever done from the admin panel.

const CONTENT_STORAGE_KEY = "motorpro_content_admin_v1";

export function getVehicleUrlOverride(vehicleId: number): string | null {
  try {
    const raw = localStorage.getItem(CONTENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const vehicles = parsed?.vehicles;
    if (!Array.isArray(vehicles)) return null;
    const match = vehicles.find((v: any) => v.id === vehicleId);
    return match?.url ? match.url : null;
  } catch {
    return null;
  }
}
